export var routerUtil = {
  getCurrentRouteInfo: function getCurrentRouteInfo(location) {
    var _location$pathname, _location$pathname$to, _location$pathname$to2, _segments$;

    var segments = ((_location$pathname = location.pathname) === null || _location$pathname === void 0 ? void 0 : (_location$pathname$to = _location$pathname.toUpperCase()) === null || _location$pathname$to === void 0 ? void 0 : (_location$pathname$to2 = _location$pathname$to.split("/")) === null || _location$pathname$to2 === void 0 ? void 0 : _location$pathname$to2.filter(function (x) {
      return x;
    })) || [];
    var firstUrlSegment = (_segments$ = segments[0]) === null || _segments$ === void 0 ? void 0 : _segments$.toUpperCase();
    var lastUrlSegment = segments[segments.length - 1];
    var isAShopRoute = firstUrlSegment == "SHOP";
    var isAMobilePayRoute = firstUrlSegment == "MOBILEPAY";
    var isEatLandingPage = lastUrlSegment == "MENU";
    var isCaterLandingPage = lastUrlSegment == "CATER" || lastUrlSegment == "CATERING";
    var isAEatRoute = firstUrlSegment == "MENU";
    var isACaterRoute = firstUrlSegment == "CATER" || firstUrlSegment == "CATERING";
    var isALocationRoute = firstUrlSegment == "LOCATIONS";
    var isStoreDetailPage = isALocationRoute && !isNaN(lastUrlSegment);
    var isHomePage = (segments === null || segments === void 0 ? void 0 : segments.length) === 0;
    var isWaitListPage = firstUrlSegment == "WAITLIST";
    var isCategoryPage = (isAEatRoute || isACaterRoute || isAShopRoute) && (segments === null || segments === void 0 ? void 0 : segments.length) > 1;
    var pageTitle = lastUrlSegment;
    if (pageTitle == 'WAITLIST') pageTitle = 'JOIN THE WAITLIST';
    if (pageTitle == 'ACCOUNT-MANAGEMENT' || pageTitle == 'account-management') pageTitle = 'MY ACCOUNT';
    if (pageTitle == 'MOBILEPAY') pageTitle = 'PAY YOUR CHECK';
    if (isStoreDetailPage) pageTitle = 'LOCATIONS';
    var routeInfo = {
      segments: segments,
      firstUrlSegment: firstUrlSegment,
      lastUrlSegment: lastUrlSegment,
      isAShopRoute: isAShopRoute,
      isAEatRoute: isAEatRoute,
      isALocationRoute: isALocationRoute,
      isStoreDetailPage: isStoreDetailPage,
      isACaterRoute: isACaterRoute,
      isEatLandingPage: isEatLandingPage,
      isCaterLandingPage: isCaterLandingPage,
      isHomePage: isHomePage,
      isAMobilePayRoute: isAMobilePayRoute,
      isCategoryPage: isCategoryPage,
      isWaitListPage: isWaitListPage,
      isAnAccountRoute: firstUrlSegment == "ACCOUNT-MANAGEMENT",
      isAccountHomePage: lastUrlSegment === "ACCOUNT-MANAGEMENT",
      isCartOrCheckout: firstUrlSegment == "CART" || firstUrlSegment == 'CHECKOUT',
      pageTitle: pageTitle
    };
    return routeInfo;
  },
  isProductDetailPage: function isProductDetailPage() {
    var detailId = window.location.hash.substr(1);

    if (detailId == null || detailId.length === 0) {
      if (window.location.search.includes("productid")) {
        return true;
      }

      if (window.location.search.includes("sku")) {
        return true;
      }

      return false;
    } else {
      return true;
    }
  }
};